import { Injectable } from '@angular/core';
import { Node } from '@alfresco/js-api';
import { Observable } from 'rxjs';
import { NodesApiService } from '@alfresco/adf-content-services';

@Injectable({
  providedIn: 'root',
})
export class WkNodesApiService {
  constructor(private readonly wkNodesApiService: NodesApiService) {}

  public updateNode(
    nodeId: string,
    nodeBody: any,
    options = null
  ): Observable<Node> {
    return this.wkNodesApiService.updateNode(nodeId, nodeBody, options);
  }
}
